import { useTranslation } from "react-i18next";

export const AreaTableHeader = () => {
  const { t } = useTranslation();

  return (
    <tr className="bg-base-200">
      <th className="w-8">
        <label>
          <input type="checkbox" className="checkbox" />
        </label>
      </th>
      <th>{t("areas.table.area")}</th>
      <th>{t("areas.table.code")}</th>
      <th>{t("areas.table.coordinate")}</th>
      <th className="w-[140px]">{t("areas.table.actions")}</th>
    </tr>
  );
}; 